"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIRE_PAYMENT_DETAILS = void 0;
exports.WIRE_PAYMENT_DETAILS = {
    ccbBeneficiaryName: 'Coastal Community Bank',
};
